import { useEffect, useState } from "react";
import dayjs from "dayjs";
import {
  AlterarFormatoData,
  CalcularDiferencaDias,
} from "../../../components/Globais";
import { DatePicker, Row, Form, Modal } from "antd";

import type { Dayjs } from "dayjs";
import TextArea from "antd/es/input/TextArea";
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";
import { useNavigate } from "react-router-dom";
import { useAtualizarPeriodo } from "../hooks/useAtualizarPeriodo";

export default function ModalEditar({
  isModalOpen,
  handleFechar,
  cotaId,
  periodoId,
  dataEspecial,
  valor,
  checkIn,
  checkOut,
}: any) {
  const [form] = Form.useForm();

  const { RangePicker } = DatePicker;
  const dateFormat = "DD/MM/YYYY";

  // Estado inicial de dos dados Postagem que serão atualizados
  const [periodoData, setPeriodoData] = useState<any>({});

  // Função que armazena os dados alterados de Apartamento
  const periodoChange = (changedValues: Partial<any>, allValues: any) => {
    setPeriodoData((prevState: any) => ({
      ...prevState,
      ...allValues,
    }));
  };

  const { atualizar, isLoading, error, success, resetError } =
    useAtualizarPeriodo();
  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Sucesso
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  const onRangeChangeMaisPeriodo = (
    dates: null | (Dayjs | null)[],
    dateStrings: string[]
  ) => {
    if (dates) {
      let diferenca = CalcularDiferencaDias(
        AlterarFormatoData(dateStrings[1]),
        AlterarFormatoData(dateStrings[0])
      );
      if (diferenca > 7) {
        showError("O período deve ser menor ou igual a 7 dias.");
      } else {
        setPeriodoData((prevState: any) => ({
          ...prevState,
          checkIn: AlterarFormatoData(dateStrings[0]), // Check-in formatado
          checkOut: AlterarFormatoData(dateStrings[1]), // Check-out formatado
        }));
      }
    }
  };

  const [errorDisplayed, setErrorDisplayed] = useState(false); // Estado para controlar se o erro já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    if (isModalOpen) {
      if (success && !successDisplayed) {
        showSuccess(success);
        setSuccessDisplayed(true);

        setTimeout(() => {
          setSuccessDisplayed(false);
          resetError();
          navigate(0);
        }, 3000);
      }

      if (error && !errorDisplayed) {
        showError(error);
        setErrorDisplayed(true);

        setTimeout(() => {
          setErrorDisplayed(false);
          resetError(); // Reseta o erro no hook
        }, 3000);
      }
    } else {
      setSuccessDisplayed(false);
      setErrorDisplayed(false);
    }
  }, [
    isModalOpen,
    success,
    showSuccess,
    showError,
    errorDisplayed,
    successDisplayed,
    navigate,
    error,
    resetError, // Adicione a função resetError às dependências
  ]);

  useEffect(() => {
    if (!form) {
      return;
    }
    form.setFieldsValue({
      periodo: [dayjs(checkIn, dateFormat), dayjs(checkOut, dateFormat)],
      dataEspecial: dataEspecial,
      valor: valor,
    });
  }, [checkIn, checkOut, dataEspecial, valor, form]);

  return (
    <Modal
      open={isModalOpen}
      title="Editar período"
      okText="Editar"
      cancelText="Cancelar"
      onCancel={handleFechar}
      confirmLoading={isLoading}
      width={300}
      onOk={() => {
        atualizar(periodoData, cotaId, periodoId);
      }}
    >
      <>{successContextHolder}</>
      <>{errorContextHolder}</>
      <Form
        form={form}
        layout="vertical"
        onValuesChange={(changedValues, allValues) =>
          periodoChange(changedValues, allValues)
        }
        initialValues={{
          periodo: [checkIn, checkOut],
          dataEspecial: dataEspecial,
          valor: valor,
        }}
      >
        <Row gutter={16}>
          <Form.Item
            name="periodo"
            label="Período"
            // {...{ wrapperCol: { span: 9, offset: 2 } }}
          >
            <RangePicker
              placeholder={["check-in", "check-out"]}
              format={dateFormat}
              size={"large"}
              onChange={onRangeChangeMaisPeriodo}
            />
          </Form.Item>
        </Row>
        <Row gutter={16}>
          <Form.Item
            name="dataEspecial"
            label="Data especial"
            style={{ width: 400 }}
            rules={[
              {
                message: "Caso a data seja especial insira aqui!",
              },
            ]}
          >
            <TextArea size="large" autoSize={{ minRows: 1, maxRows: 1 }} />
          </Form.Item>
        </Row>
        <Row gutter={16}>
          <Form.Item
            name="valor"
            label="Valor"
            style={{ width: 400 }}
            rules={[{ required: false, message: "Por favor insira um valor!" }]}
          >
            <TextArea size="large" autoSize={{ minRows: 1, maxRows: 1 }} />
          </Form.Item>
        </Row>
      </Form>
    </Modal>
  );
}
